import styled, {css} from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

export const StyledSearchAssistModal = styled.div<{ top: number, left: number, isOpen: boolean, height: number }>`
    position: fixed;
    top: ${({top}) => `${top}px`};
    height: ${({height}) => `${height}px`};
    left: 0;
    right: 0;
    width: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'max-width')},
    ${({theme}) => theme.container.maxWidth});
    margin: 0 auto;
    max-width: 100%;
    overflow-y: auto;
    background: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'bg-color')},
    ${({theme}) => theme.colors.background});
    box-shadow: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'box-shadow')}, 0px 4px 8px rgba(0, 0, 0, 0.1));
    display: ${({isOpen}) => (isOpen ? 'block' : 'none')};
    z-index: ${({isOpen}) => (isOpen ? '1111' : '-1')};
    max-height: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'max-height')}, 80vh);
    border-radius:var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'border-radius')}, 0);
    padding:var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'padding')}, 0); 
`

export const StyledSearchAssistModalHeader = styled.div`
    padding:var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'header-padding')}, 8px 10px);
    display: flex;
    gap: 25px;
    position: sticky;
    top: 0;
    z-index: 9;
    background: ${({theme}) => theme.colors.background};

    & > div {
        margin: 0;
    }
}
`
export const StyledSearchAssistButtonClose = styled.button`
    background: none;
    outline: none;
    border: none;
    margin-left: auto;
    cursor: pointer;
    padding: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'close-padding')}, 3px);
    width: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'close-width')}, 24px);
    height: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'close-height')}, 24px);

    svg {
        width: 100%;
        height: 100%;

        path {
            fill: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'close-color')},
            ${({theme}) => theme.colors.primary});
        }
    }

    &:hover {
        svg {
            path {
                fill: var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'close-hover-color')},
                ${({theme}) => theme.colors.primaryHover});
            }
        }
    }


`
export const StyledSearchAssistModalContent = styled.div`
    padding:var(${GLOBAL_STYLE_CONFIG.variable('search-modal', 'content-padding')}, 8px 10px);
    overflow: hidden;
`